/**
 * Search UI and AJAX helpers.
 */
export default function initSearch() {

	const langMenu = document.querySelector( '.lang-menu' );
	const searchToggle = document.querySelector( '#header-search-toggle' );
	const searchTrigger = document.querySelector( '.header-search__trigger' );
	const searchPanel = document.querySelector( '.header-search__panel' );

	/* -----------------------------
	 * SEARCH TOGGLE
	 * ----------------------------- */
/* -----------------------------
 * SEARCH TOGGLE
 * ----------------------------- */
if ( searchToggle && searchTrigger && searchPanel ) {

	searchTrigger.addEventListener( 'click', ( event ) => {

		event.preventDefault();

		searchToggle.checked = ! searchToggle.checked;

		if ( searchToggle.checked ) {

			setTimeout( () => {

				const searchInput =
					searchPanel.querySelector( '.search-field' );

				if ( searchInput ) {
					searchInput.focus();
				}

			}, 50 );

		}

	} );

	document.addEventListener( 'click', ( event ) => {

		const insideSearch =
			searchTrigger.contains( event.target ) ||
			searchPanel.contains( event.target );

		if ( ! insideSearch ) {
			searchToggle.checked = false;
		}

	} );

}
	/* -----------------------------
	 * LANGUAGE MENU
	 * ----------------------------- */
	if ( ! langMenu ) {
		return;
	}

	let listenersBound = false;

	function bindLangMenuEvents( gtranslateWrapper ) {

		if ( listenersBound ) {
			return;
		}

		listenersBound = true;

		langMenu.addEventListener( 'mouseenter', () => {
			gtranslateWrapper.classList.add( 'open-lng' );
		} );

		langMenu.addEventListener( 'mouseleave', () => {
			gtranslateWrapper.classList.remove( 'open-lng' );
		} );

	}

	function mountGtranslateWrapper() {

		const gtranslateWrapper = document.querySelector( '.gtranslate_wrapper' );

		if ( ! gtranslateWrapper ) {
			return false;
		}

		if ( ! langMenu.contains( gtranslateWrapper ) ) {
			langMenu.appendChild( gtranslateWrapper );
		}

		bindLangMenuEvents( gtranslateWrapper );

		return true;

	}

	if ( mountGtranslateWrapper() ) {
		return;
	}

	const observer = new MutationObserver( () => {

		if ( mountGtranslateWrapper() ) {
			observer.disconnect();
		}

	} );

	observer.observe( document.body, {
		childList: true,
		subtree: true,
	} );

}